import React from "react";
import { Box, Typography, Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { ROUTE_MAIN } from "../../constants/routes";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const PrivacyPolicy = () => {
  return (
    <Box
      sx={{
        maxWidth: 800,
        margin: "0 auto",
        padding: { xs: 2, sm: 4 },
        minHeight: "100vh",
        backgroundColor: "#fff",
      }}
    >
      <Link
        component={RouterLink}
        to={ROUTE_MAIN}
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 0.5,
          color: "#756DE9",
          textDecoration: "none",
          fontSize: "14px",
          fontWeight: 500,
          mb: 3,
          "&:hover": { color: "#5a4dbf" },
        }}
      >
        <ArrowBackIcon fontSize="small" /> Back
      </Link>

      <Typography variant="h4" component="h1" sx={{ fontWeight: 700, mb: 3, color: "#1A1A35" }}>
        Privacy Policy
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Last updated: {new Date().toLocaleDateString()}
      </Typography>

      <Typography variant="body1" paragraph>
        This Privacy Policy describes how we collect, use, and protect your information when you use our platform.
      </Typography>

      <Typography variant="h6" sx={{ fontWeight: 600, mt: 3, mb: 1 }}>
        1. Information We Collect
      </Typography>
      <Typography variant="body1" paragraph>
        We may collect personal information such as your name, email address, phone number, and profile data when you register or use our services. We also collect usage data to improve our platform.
      </Typography>

      <Typography variant="h6" sx={{ fontWeight: 600, mt: 3, mb: 1 }}>
        2. How We Use Your Information
      </Typography>
      <Typography variant="body1" paragraph>
        Your information is used to provide and improve our services, communicate with you, and ensure the security of our platform. We do not sell your personal data to third parties.
      </Typography>

      <Typography variant="h6" sx={{ fontWeight: 600, mt: 3, mb: 1 }}>
        3. Data Security
      </Typography>
      <Typography variant="body1" paragraph>
        We implement appropriate technical and organisational measures to protect your personal data against unauthorised access, alteration, or destruction.
      </Typography>

      <Typography variant="h6" sx={{ fontWeight: 600, mt: 3, mb: 1 }}>
        4. Your Rights
      </Typography>
      <Typography variant="body1" paragraph>
        You have the right to access, correct, or delete your personal data. You may also object to or restrict certain processing. Contact us at{" "}
        <Link href="mailto:queries@seevi.in" color="primary">
          queries@seevi.in
        </Link>{" "}
        for any privacy-related requests.
      </Typography>

      <Typography variant="h6" sx={{ fontWeight: 600, mt: 3, mb: 1 }}>
        5. Contact
      </Typography>
      <Typography variant="body1" paragraph>
        For questions about this Privacy Policy, please contact us at{" "}
        <Link href="mailto:queries@seevi.in" color="primary">
          queries@seevi.in
        </Link>
        .
      </Typography>
    </Box>
  );
};

export default PrivacyPolicy;
